import { render, staticRenderFns } from "./collis.vue?vue&type=template&id=cf8f7aa2&"
import script from "./collis.vue?vue&type=script&lang=js&"
export * from "./collis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports